import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Profile } from 'src/app/models/profile.model';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { StatefulService } from 'src/app/shared/services/stateful.service';

@Component({
  selector: 'app-maintenances',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Tareas y técnicos</h1>
        <xng-breadcrumb></xng-breadcrumb>
      </div>
    </div>

    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">
        <ul
          app-nav-tasks
          [currentView]="currentView"
          class="sidebar-zazz list-unstyled"
        ></ul>
      </div>

      <main class="flex-fill ms-auto" aria-labelledby="maintenance-calendar-title">
        <div class="d-flex align-items-center justify-content-between gap-3 mb-3">
          <h2 id="maintenance-calendar-title" class="mt-2 mt-md-0 mb-0">Calendario</h2>
          <a
            *ngIf="authService.hasPermission('can_create_tasks')"
            routerLink="/maintenances/tasks/create"
            class="btn btn-zazz-dark"
          >
            <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>
            Agregar tarea
          </a>
        </div>

        @if (profile(); as currentProfile) {
          <div class="card rounded-5 shadow overflow-hidden">
            <div class="card-body">
              <app-zazz-calendar
                section="tasks"
                [currentProfile]="currentProfile"
              ></app-zazz-calendar>
            </div>
          </div>
        } @else {
          <div class="alert alert-warning" role="alert">
            No hay un cliente activo para mostrar el calendario.
          </div>
        }
      </main>
    </div>
  `,
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaintenancesComponent {
  private readonly storageService = inject(StorageService);
  private readonly statefulService = inject(StatefulService);

  readonly authService = inject(AuthService);
  readonly icons = inject(IconsService);
  readonly currentView = 'maintenances';
  readonly profile = signal<Profile | null>(
    this.storageService.getItem(STORAGE_KEYS.PROFILE)?.profile ?? null
  );

  constructor() {
    this.statefulService.reloadDashboardListener$
      .pipe(takeUntilDestroyed())
      .subscribe(profile => this.profile.set(profile));
  }
}
